import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { twMerge } from "tailwind-merge";
enum SeparatorType {
  SeparatorStart = "start",
  SeparatorEnd = "end",
}
function generatePagination(currentPage: number, max: number) {
  const firstPage = 1;
  const lastPage = max;
  const offsetLeft = [...Array(5).keys()].map(index => currentPage - index <= firstPage || currentPage - index === currentPage ? undefined : Math.abs(index - currentPage)).reverse().filter((page): page is number => page !== undefined);
  const offsetRight = [...Array(5).keys()].map(index => currentPage + index >= lastPage || currentPage + index === currentPage ? undefined : currentPage + index).filter((page): page is number => page !== undefined);

  // Balance the offsets
  while (offsetLeft.length + offsetRight.length > 4) {
    if (offsetLeft.length > offsetRight.length) {
      offsetLeft.shift();
      continue;
    }
    if (offsetLeft.length < offsetRight.length) {
      offsetRight.pop();
      continue;
    }
    offsetLeft.shift();
    offsetRight.pop();
  }
  let pagination: (number | SeparatorType)[] = [firstPage];
  if (Math.abs(firstPage - currentPage) > 3) {
    pagination.push(SeparatorType.SeparatorStart);
  }
  pagination = pagination.concat(offsetLeft);
  if (currentPage !== firstPage && currentPage !== lastPage) {
    pagination.push(currentPage);
  }
  pagination = pagination.concat(offsetRight);
  if (Math.abs(lastPage - currentPage) > 3) {
    pagination.push(SeparatorType.SeparatorEnd);
  }
  if (lastPage !== firstPage) {
    pagination.push(lastPage);
  }
  return pagination;
}
function Separator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div>...</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
  className?: string;
}
export default function Pagination(t0) {
  const $ = _c(33);
  const {
    current,
    total,
    onChange,
    className
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = function createOnChange(page) {
      return () => onChange(page);
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const createOnChange = t1;
  let t2;
  let t3;
  let t4;
  if ($[2] !== className || $[3] !== createOnChange || $[4] !== current || $[5] !== total) {
    const pagination = generatePagination(current, total);
    if ($[9] !== className) {
      t2 = twMerge("mx-auto flex gap-2", className);
      $[9] = className;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    const t5 = current === 1;
    const t6 = current - 1;
    let t7;
    if ($[11] !== createOnChange || $[12] !== t6) {
      t7 = createOnChange(t6);
      $[11] = createOnChange;
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <ChevronLeftIcon className="h-3 w-3 sm:h-4 sm:w-4" />;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    if ($[15] !== t5 || $[16] !== t7) {
      t3 = <button aria-label={"F\xF6reg\xE5ende sida"} disabled={t5} onClick={t7} className="disabled:opacity-60">{t8}</button>;
      $[15] = t5;
      $[16] = t7;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    let t9;
    if ($[18] !== createOnChange || $[19] !== current) {
      t9 = page_0 => typeof page_0 === "number" ? <button key={page_0} onClick={createOnChange(page_0)} disabled={page_0 === current} aria-current={page_0 === current ? "page" : "false"} className={twMerge("h-6 w-6 rounded-full text-sm transition-colors sm:h-8 sm:w-8", "aria-[current=page]:bg-slate-200 dark:aria-[current=page]:bg-slate-600", "hover:bg-slate-200 dark:hover:bg-slate-600")}>{page_0}</button> : <Separator key={page_0} />;
      $[18] = createOnChange;
      $[19] = current;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    t4 = pagination.map(t9);
    $[2] = className;
    $[3] = createOnChange;
    $[4] = current;
    $[5] = total;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  const t5 = current === total;
  const t6 = current + 1;
  let t7;
  if ($[21] !== createOnChange || $[22] !== t6) {
    t7 = createOnChange(t6);
    $[21] = createOnChange;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ChevronRightIcon className="h-3 w-3 sm:h-4 sm:w-4" />;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t5 || $[26] !== t7) {
    t9 = <button aria-label={"N\xE4sta sida"} disabled={t5} onClick={t7} className="disabled:opacity-60">{t8}</button>;
    $[25] = t5;
    $[26] = t7;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t2 || $[29] !== t3 || $[30] !== t4 || $[31] !== t9) {
    t10 = <nav className={t2}>{t3}{t4}{t9}</nav>;
    $[28] = t2;
    $[29] = t3;
    $[30] = t4;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
}